import React from "react";

const Support = () => {
  return (
    <div>
      {/* Inner Page */}
      <div className="inner-banner py-5">
        <section className="w3l-breadcrumb text-left py-sm-5">
          <div className="container">
            <div className="w3breadcrumb-gids">
              <div className="w3breadcrumb-left text-left">
                <h2 className="inner-w3-title mt-sm-5 mt-4">Contact Us</h2>
              </div>
              <div className="w3breadcrumb-right">
                <ul className="breadcrumbs-custom-path">
                  <li>
                    <a href="/Home">Home</a>
                  </li>
                  <li className="active">
                    <span className="fas fa-angle-double-right mx-2"></span>{" "}
                    Contact Us
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Contact Form */}
      <section className="w3l-contact-main" id="contact">
        <div className="contact-infhny py-5 pb-0">
          <div className="container py-lg-3 pb-0">
            <div className="top-map">
              <div className="map-content-9">
                <form
                  action="https://sendmail.w3layouts.com/submitForm"
                  method="post"
                >
                  <div className="form-top1">
                    <div className="w3header-section text-center">
                      <h6 className="title-subw3hny">Get In Touch</h6>
                      <h3 className="title-w3l mb-0">
                        Fill the form and send your query
                      </h3>
                      <p className="mb-lg-5 mb-4 text-center">
                        We have made it easy for clients to reach us and get
                        their solutions weaved
                      </p>
                    </div>

                    <div className="form-top">
                      <div className="form-top-left">
                        <input
                          type="text"
                          name="w3lName"
                          id="w3lName"
                          placeholder="Name"
                          required=""
                        />
                        <input
                          type="number"
                          name="w3lPhone"
                          placeholder="Your phone number"
                          required=""
                        />
                        <input
                          type="email"
                          name="w3lSender"
                          id="w3lSender"
                          placeholder="Email*"
                          required=""
                        />
                        <input
                          type="text"
                          name="w3lSubject"
                          id="w3lName"
                          placeholder="Subject"
                          required=""
                        />
                      </div>
                      <div className="form-top-righ">
                        <textarea
                          name="w3lMessage"
                          id="w3lMessage"
                          placeholder="Message*"
                          required=""
                        ></textarea>
                      </div>
                    </div>
                    <div className="text-lg-right text-center">
                      <button
                        type="submit"
                        className="btn btn-style btn-primary"
                      >
                        Submit Now <i className="fas fa-paper-plane ms-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="w3l-contact-main py-5" id="contact2">
        <div className="container py-md-4 py-3">
          <div className="w3l-contact-info top-map">
            <div className="row contact-infos justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="single-contact-infos">
                  <div className="icon-box">
                    <span className="fas fa-map-marked-alt"></span>
                  </div>
                  <div className="text-box">
                    <h3 className="mb-2">Our Location</h3>
                    <p>
                      <a href="https://www.bing.com/maps/search?name=Siddhartha+High+School&trfc=&mepi=0%7E%7EEmbedded%7ELargeMapLink&FORM=MPSRPL&style=r&q=Siddhartha+High+School&ss=id.ypid%3AYN4070x252393437&ppois=17.49513816833496_78.45491790771484_Siddhartha+High+School&cp=17.500929%7E78.457872&lvl=16">
                        Uttam Gardens, Algole Road, Zaheerabadm,Sangareddy Dist,
                        Telangana , Pincode:502220
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-md-0 mt-4">
                <div className="single-contact-infos">
                  <div className="icon-box">
                    <span className="fas fa-phone-alt"></span>
                  </div>
                  <div className="text-box">
                    <h3 className="mb-2">Give us a call</h3>
                    <p>
                      <a href="tel:+91 7780663677">+91 7780663677</a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-lg-0 mt-4">
                <div className="single-contact-infos">
                  <div className="icon-box">
                    <span className="fas fa-envelope-open-text"></span>
                  </div>
                  <div className="text-box">
                    <h3 className="mb-2">Help Desk</h3>
                    <p>
                      <a href="mailto:siddharthahighschool4@gmail.com">
                        siddharthahighschool4@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Map */}
      <section className="w3l-contact-main" id="contact">
        <div className="map">
          <a
            href="https://www.bing.com/maps/search?name=Siddhartha+High+School&trfc=&mepi=0%7E%7EEmbedded%7ELargeMapLink&FORM=MPSRPL&style=r&q=Siddhartha+High+School&ss=id.ypid%3AYN4070x252393437&ppois=17.49513816833496_78.45491790771484_Siddhartha+High+School&cp=17.500929%7E78.457872&lvl=16"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block" }}
          >
            <img
              src="assets/images/Siddarthahighschool.PNG"
              allowFullScreen=""
              title="location-map"
              style={{
                pointerEvents: "none",
                width: "100%",
                height: "300",
                objectFit: "fill",
              }}
            ></img>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Support;
